import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ActorProfileMaster, DashboardState } from "../../../types";

const initialState: DashboardState = {
    viewAllEmployees: [],
    selectedSchedulesForViewDetails: [],
    selectedScheduleForViewShiftDetails: null,
};

export const DashboardSlice = createSlice({
    name: "dashboard",
    initialState: initialState,
    reducers: {
        setViewAllEmployees: (state, action: PayloadAction<ActorProfileMaster[]>) => {
            state.viewAllEmployees = action.payload;
        },

        clearViewAllEmployees: (state) => {
            state.viewAllEmployees = [];
        },
    },
    extraReducers: {},
});

export const { setViewAllEmployees, clearViewAllEmployees } = DashboardSlice.actions;
export default DashboardSlice.reducer;
